export const COMPANY_NAME = "Ledgernalysis";

export const LOADING_TEXT = "Loading...";

export const SOURCE_PAGE_HEADING = "Sources";
export const SOURCE_PAGE_DESCRIPTION = "You can manage your sources here.";
export const WORKSPACES_PAGE_HEADING = "Workspaces";

export const DASHBOARD_PAGE_HEADING = "Dashboard";
export const DASHBOARD_PAGE_DESCRIPTION = "Get a quick overview of your data.";

export const GUIDE_PAGE_HEADING = "Ledgernalysis Guide";
export const ICON_SOURCE =
  "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/";
export const GUIDE_PAGE_DESCRIPTION =
  "Quick guide to get started with Ledgernalysis";

export const SOURCE_ENTRIES_PAGE_HEADING = "Source Entries";
export const SOURCE_ENTRIES_PAGE_DESCRIPTION =
  "You can manage your source entries here.";

export const GROUP_TYPES = [
  { label: "Address Balance (BALA)", value: "BALA" },
  { label: "Exchange Balance (EXCH)", value: "EXCH" },
  { label: "Risk Assessment (RISK)", value: "RISK" },
  { label: "Signature (SIGN)", value: "SIGN" },
  { label: "xPub Key (PUBK)", value: "PUBK" },
];

export const ENTRY_TYPES = [
  {
    symbol: "BALA",
    name: "Address Balance",
  },
  {
    symbol: "EXCH",
    name: "Exhange Balance",
  },
  {
    symbol: "RISK",
    name: "Risk Assesment",
  },
  {
    symbol: "SIGN",
    name: "Signature Verification",
  },
  {
    symbol: "PUBK",
    name: "xPub Key Derivation",
  },
  {
    symbol: "DEFI",
    name: "Defi Protocol Balance",
  },
];

export const ADDRESS_TYPES = [
  { label: "P2PKH", value: "P2PKH" },
  { label: "P2SH", value: "P2SH" },
  { label: "P2WPKH", value: "P2WPKH" },
];

export const EXCHANGE_NETWORKS = [
  {
    label: "VALR",
    value: "VALR",
    img: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/valr.jpg",
  },
  {
    label: "CRYPTO.COM",
    value: "CRYPTO.COM",
    img: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/cryptodotcom.png",
  },
  // {
  //   label: "OKX",
  //   value: "OKX",
  //   img: "https://static.okx.com/cdn/assets/imgs/221/B1041DB14722953A.png",
  // },
  // {
  //   label: "DERIBIT",
  //   value: "DERIBIT",
  //   img: "https://logowik.com/content/uploads/images/deribit8863.jpg",
  // },
  {
    label: "LUNO",
    value: "LUNO",
    img: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/luno.png",
  },
  // {
  //   label: "BINANCE",
  //   value: "BINANCE",
  //   img: "https://public.bnbstatic.com/20190405/eb2349c3-b2f8-4a93-a286-8f86a62ea9d8.png",
  // },
  {
    label: "KRAKEN",
    value: "KRAKEN",
    img: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/kraken.png",
  },


];

export const ASSETS = [
  {
    label: "Ethereum",
    name: "eth",
    icon: "https://cryptologos.cc/logos/ethereum-eth-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "ETH",
    name: "ether",
    icon: "https://cryptologos.cc/logos/ethereum-eth-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Bitcoin",
    name: "btc",
    icon: "https://cryptologos.cc/logos/bitcoin-btc-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Solana",
    name: "sol",
    icon: "https://cryptologos.cc/logos/solana-sol-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Avalanche",
    name: "ava",
    icon: "https://cryptologos.cc/logos/avalanche-avax-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Polygon",
    name: "poly",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/matic.png",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Matic",
    name: "matic",
    icon: "https://cryptologos.cc/logos/polygon-matic-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Polkadot",
    name: "dot",
    icon: "https://cryptologos.cc/logos/polkadot-new-dot-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Cardano",
    name: "cardano",
    icon: "https://cryptologos.cc/logos/cardano-ada-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "ADA",
    name: "ada",
    icon: "https://cryptologos.cc/logos/cardano-ada-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "LUNA",
    name: "luna",
    icon: "https://cryptologos.cc/logos/terra-luna-luna-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Terra",
    name: "terra",
    icon: "https://cryptologos.cc/logos/terra-luna-luna-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Chainlink",
    name: "chainlink",
    icon: "https://cryptologos.cc/logos/chainlink-link-logo.png?v=022",
    category: "protocol",
    isActive: true,
  },
  {
    label: "LINK",
    name: "link",
    icon: "https://cryptologos.cc/logos/chainlink-link-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Tether",
    name: "usdt",
    icon: "https://cryptologos.cc/logos/tether-usdt-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "USDC",
    name: "usdc",
    icon: "https://cryptologos.cc/logos/usd-coin-usdc-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "BUSD",
    name: "busd",
    icon: "https://cryptologos.cc/logos/binance-usd-busd-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Dogecoin",
    name: "doge",
    icon: "https://cryptologos.cc/logos/dogecoin-doge-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Shiba Inu",
    name: "shiba-inu",
    icon: "https://cryptologos.cc/logos/shiba-inu-shib-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Uniswap",
    name: "uniswap",
    icon: "https://cryptologos.cc/logos/uniswap-uni-logo.png?v=022",
    category: "DeFi",
    isActive: true,
  },
  {
    label: "SushiSwap",
    name: "sushiswap",
    icon: "https://cryptologos.cc/logos/sushiswap-sushi-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Aave",
    name: "aave",
    icon: "https://cryptologos.cc/logos/aave-aave-logo.png?v=022",
    category: "DeFi",
    isActive: true,
  },
  {
    label: "Compound",
    name: "compound",
    icon: "https://cryptologos.cc/logos/compound-comp-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Maker",
    name: "maker",
    icon: "https://cryptologos.cc/logos/maker-mkr-logo.png?v=022",
    category: "DeFi",
    isActive: true,
  },
  {
    label: "Yearn Finance",
    name: "yearn-finance",
    icon: "https://cryptologos.cc/logos/yearn-finance-yfi-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Curve Finance",
    name: "curve-finance",
    icon: "https://cryptologos.cc/logos/curve-dao-token-crv-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "PancakeSwap",
    name: "pancakeswap",
    icon: "https://cryptologos.cc/logos/pancakeswap-cake-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "MetaMask",
    name: "metamask",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/metamask.png",
    category: "wallet",
    isActive: true,
  },
  {
    label: "Trust Wallet",
    name: "trust-wallet",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/trust.svg",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Ledger",
    name: "ledger",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/ledger.jpg",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Trezor",
    name: "trezor",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/trezor.png",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Phantom",
    name: "phantom",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/phantom.svg",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Exodus",
    name: "exodus",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/exodus.png",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Zerion",
    name: "zerion",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/zerion.png",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Rainbow Wallet",
    name: "rainbow-wallet",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/rainbow.png",
    category: "wallet",
    isActive: false,
  },
  {
    label: "MyEtherWallet",
    name: "myetherwallet",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/myetherwallet.png",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Atomic Wallet",
    name: "atomic-wallet",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/atomic.png",
    category: "wallet",
    isActive: false,
  },
  {
    label: "Optimism",
    name: "optimism",
    icon: "https://cryptologos.cc/logos/optimism-ethereum-op-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Algorand",
    name: "algorand",
    icon: "https://cryptologos.cc/logos/algorand-algo-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "BNB",
    name: "bnb",
    icon: "https://cryptologos.cc/logos/binance-coin-bnb-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Litecoin",
    name: "ltc",
    icon: "https://cryptologos.cc/logos/litecoin-ltc-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "XRP",
    name: "xrp",
    icon: "https://cryptologos.cc/logos/xrp-xrp-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Tron",
    name: "tron",
    icon: "https://cryptologos.cc/logos/tron-trx-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Bitcoin Cash",
    name: "bitcoin-cash",
    icon: "https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "Arbitrum",
    name: "arbitrum",
    icon: "https://cryptologos.cc/logos/arbitrum-arb-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Cosmos",
    name: "cosmos",
    icon: "https://cryptologos.cc/logos/cosmos-atom-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "EOS",
    name: "eos",
    icon: "https://cryptologos.cc/logos/eos-eos-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Fantom",
    name: "fantom",
    icon: "https://cryptologos.cc/logos/fantom-ftm-logo.png?v=022",
    category: "blockchain",
    isActive: true,
  },
  {
    label: "Stellar",
    name: "stellar",
    icon: "https://cryptologos.cc/logos/stellar-xlm-logo.png?v=022",
    category: "token",
    isActive: true,
  },
  {
    label: "0x Protocol",
    name: "0x-protocol",
    icon: "https://cryptologos.cc/logos/0x-zrx-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "1Inch",
    name: "1inch",
    icon: "https://cryptologos.cc/logos/1inch-1inch-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Balancer",
    name: "balancer",
    icon: "https://cryptologos.cc/logos/balancer-bal-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Idex",
    name: "idex",
    icon: "https://cryptologos.cc/logos/idex-idex-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Osmosis",
    name: "osmosis",
    icon: "https://cryptologos.cc/logos/osmosis-osmo-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Bancor",
    name: "bancor",
    icon: "https://cryptologos.cc/logos/bancor-bnt-logo.png?v=022",
    category: "DeFi",
    isActive: false,
  },
  {
    label: "Maker DAO",
    name: "maker-dao",
    icon: "https://cryptologos.cc/logos/maker-mkr-logo.png?v=022",
    category: "DeFi",
    isActive: true,
  },
  {
    label: "AAVE V2",
    name: "aave-v2",
    icon: "https://cryptologos.cc/logos/aave-aave-logo.png?v=022",
    category: "protocol",
    isActive: true,
  },
  {
    label: "AAVE V3",
    name: "aave-v3",
    icon: "https://cryptologos.cc/logos/aave-aave-logo.png?v=022",
    category: "protocol",
    isActive: true,
  },
  {
    label: "0X",
    name: "0x",
    icon: "https://cryptologos.cc/logos/0x-zrx-logo.png?v=022",
    category: "protocol",
    isActive: false,
  },
  {
    label: "AAVE V1",
    name: "aave-v1",
    icon: "https://cryptologos.cc/logos/aave-aave-logo.png?v=022",
    category: "protocol",
    isActive: true,
  },
  {
    label: "1Inch Network",
    name: "1inch-network",
    icon: "https://cryptologos.cc/logos/1inch-1inch-logo.png?v=022",
    category: "protocol",
    isActive: false,
  },
  {
    label: "ADAO",
    name: "adao",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/adao.png",
    category: "protocol",
    isActive: false,
  },
  {
    label: "Binance",
    name: "binance",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/bnb.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "Coinbase",
    name: "coinbase",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/coinbase.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "Kraken",
    name: "kraken",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/kraken.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "Huobi",
    name: "huobi",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/huobi.png",
    category: "exchange",
    isActive: false,
  },
  {
    label: "Gemini",
    name: "gemini",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/gemini.png",
    category: "exchange",
    isActive: false,
  },
  {
    label: "Bitfinex",
    name: "bitfinex",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/bitfinex.png",
    category: "exchange",
    isActive: false,
  },
  {
    label: "KuCoin",
    name: "kucoin",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/kucoin.png",
    category: "exchange",
    isActive: false,
  },
  {
    label: "Bitwise",
    name: "bitwise",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/bitwise.jpg",
    category: "exchange",
    isActive: true,
  },
  {
    label: "Deribit",
    name: "deribit",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/deribit.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "Crypto.com",
    name: "crypto-com",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/cryptodotcom.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "VALR",
    name: "valr",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/valr.jpg",
    category: "exchange",
    isActive: true,
  },
  {
    label: "LUNO",
    name: "luno",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/luno.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "ByBit",
    name: "bybit",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/bybit.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "BitMEX",
    name: "bitmex",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/bitmex.png",
    category: "exchange",
    isActive: true,
  },
  {
    label: "CEX.io",
    name: "cex-io",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/cex-io.svg",
    category: "exchange",
    isActive: false,
  },
  {
    label: "AltcoinTrader",
    name: "altcointrader",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/altcointrader.png",
    category: "exchange",
    isActive: false,
  },
  {
    label: "Bittrex",
    name: "bittrex",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/bittrex.jpg",
    category: "exchange",
    isActive: false,
  },
  {
    label: "PolonieX",
    name: "poloniex",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/poloniex.png",
    category: "exchange",
    isActive: false,
  },
  {
    label: "BlockFi",
    name: "blockfi",
    icon: "https://raw.githubusercontent.com/silversixpence-crypto/cryptocurrency-icons/master/128/icon/blockfi.png",
    category: "exchange",
    isActive: false,
  },
];

export const BLOCKCHAIN_NETWORKS = [
  {
    label: "ADA (Cardano)",
    value: "ADA",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/ada.png",
  },
  {
    label: "ALGO (Algorand)",
    value: "ALGO",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/algo.png",
  },
  {
    label: "ARB (Arbitrum)",
    value: "ARB",
    img: "https://seeklogo.com/images/A/arbitrum-arb-logo-1AA8787597-seeklogo.com.png",
  },
  {
    label: "ATOM (Cosmos)",
    value: "ATOM",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/atom.png",
  },
  {
    label: "BCH (Bitcoin Cash)",
    value: "BCH",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/bch.png",
  },
  {
    label: "BNB (Binance Coin)",
    value: "BNB",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/bnb.png",
  },
  {
    label: "BSC (Binance Smartchain)",
    value: "BSC",
    img: "https://seeklogo.com/images/B/binance-smart-chain-bsc-logo-9C34053D61-seeklogo.com.png",
  },
  {
    label: "BTC (Bitcoin)",
    value: "BTC",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/btc.png",
  },
  {
    label: "DOGE (Dogecoin)",
    value: "DOGE",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/doge.png",
  },
  {
    label: "DOT (Polkadot)",
    value: "DOT",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/dot.png",
  },
  {
    label: "EOS (EOS)",
    value: "EOS",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/eos.png",
  },
  {
    label: "ETH (Ethereum)",
    value: "ETH",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/eth.png",
  },
  {
    label: "ETC (Ethereum Classic)",
    value: "ETC",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/etc.png",
  },
  {
    label: "EWT (Energy Web Token)",
    value: "EWT",
    img: "data:image/png;base64,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",
  },
  {
    label: "FLOW (Flow)",
    value: "FLOW",
    img: "data:image/png;base64,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",
  },
  {
    label: "FTM (Fantom)",
    value: "FTM",
    img: "https://atomicwallet.io/images/crypto-icons/FTM.svg",
  },
  {
    label: "GNO (Gnosis)",
    value: "GNO",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/gno.png",
  },
  {
    label: "KCC (KuCoin Community Chain)",
    value: "KCC",
    img: "data:image/png;base64,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",
  },
  {
    label: "KSM (Kusama)",
    value: "KSM",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/ksm.png",
  },
  {
    label: "LUNA (Terra)",
    value: "LUNA",
    img: "https://www.business2community.com/wp-content/uploads/2022/04/terra-luna.png",
  },
  {
    label: "LTC (Litecoin)",
    value: "LTC",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/ltc.png",
  },
  {
    label: "MATIC (Polygon)",
    value: "MATIC",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/matic.png",
  },
  {
    label: "MOVR (Moonriver)",
    value: "MOVR",
    img: "data:image/png;base64,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",
  },
  {
    label: "OPT (Optimism)",
    value: "OPT",
    img: "https://cryptologos.cc/logos/optimism-ethereum-op-logo.png?v=002",
  },
  {
    label: "OMNI (Omni Layer)",
    value: "OMNI",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/omni.png",
  },
  {
    label: "SOL (Solana)",
    value: "SOL",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/sol.png",
  },
  {
    label: "TRX (Tron)",
    value: "TRX",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/trx.png",
  },
  {
    label: "XTZ (Tezos)",
    value: "XTZ",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/xtz.png",
  },
  {
    label: "ATOM (Cosmos) STAKE",
    value: "ATOM STAKE",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/atom.png",
  },
  {
    label: "AVAX (Avalanche)",
    value: "AVAX",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/avax.png",
  },
  {
    label: "BASIS (Basis Cash)",
    value: "BASIS",
    img: "https://s2.coinmarketcap.com/static/img/coins/64x64/7813.png",
  },
  {
    label: "BUSD (Binance USD)",
    value: "BUSD",
    img: "https://wp-api.zipmex.com/wp-content/uploads/2022/05/Binance-USD-BUSD.png",
  },
  {
    label: "BUSD (Binance USD)",
    value: "BSCUSD",
    img: "https://wp-api.zipmex.com/wp-content/uploads/2022/05/Binance-USD-BUSD.png",
  },
  {
    label: "DAI (Dai)",
    value: "DAI",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/dai.png",
  },
  {
    label: "DG (Decentral Games)",
    value: "DG",
    img: "data:image/png;base64,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",
  },
  {
    label: "DOT (Polkadot) STAKE",
    value: "DOT STAKE",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/dot.png",
  },
  {
    label: "KAVA (Kava.io)",
    value: "KAVA",
    img: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png",
  },
  {
    label: "KSM (Kusama) STAKE",
    value: "KSM STAKE",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/ksm.png",
  },
  {
    label: "LINK (Chainlink)",
    value: "LINK",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/link.png",
  },
  {
    label: "LUNA (Terra) STAKE",
    value: "LUNA STAKE",
    img: "https://www.business2community.com/wp-content/uploads/2022/04/terra-luna.png",
  },
  {
    label: "PAXG (PAX Gold)",
    value: "PAXG",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/paxg.png",
  },
  {
    label: "SHIB (Shiba Inu)",
    value: "SHIB",
    img: "https://upload.wikimedia.org/wikipedia/en/5/53/Shiba_Inu_coin_logo.png",
  },
  {
    label: "TRX (Tron) STAKE",
    value: "TRX STAKE",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/trx.png",
  },
  {
    label: "UNI (Uniswap)",
    value: "UNI",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/uni.png",
  },
  {
    label: "USDC (USD Coin)",
    value: "USDC",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/usdc.png",
  },
  {
    label: "USDT (Tether)",
    value: "USDT",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/usdt.png",
  },
  {
    label: "XLM (Stellar)",
    value: "XLM",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/xlm.png",
  },
  {
    label: "XMR (Monero)",
    value: "XMR",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/xmr.png",
  },
  {
    label: "XRP (Ripple)",
    value: "XRP",
    img: "https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/xrp.png",
  },
];

// INFO: For development purposes only
// const uniqueAssets = BLOCKCHAIN_NETWORKS?.tokens;
// delete uniqueAssets["version"];
// delete uniqueAssets["datetimestamp"];
// const uniqueAssetsArray = Object.keys(uniqueAssets);

// const missingAssets = uniqueAssetsArray.filter((asset) => {
//   return !BLOCKCHAIN_NETWORKS.some((network) => network.value === asset);
// });
// console.log(missingAssets);
